<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Способы доставки"
    >
      <v-dialog v-model="editDialog">
        <template #activator="{ on, attrs }">
          <v-btn
            color="red"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
          >
            Новая доставка
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Редактирование доставки</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Название"
                />
                <v-text-field
                  v-model="editedItem.sum"
                  label="Стоимость"
                />
                <v-text-field
                  v-model="editedItem.freeForSum"
                  label="Бесплатно при сумме заказа"
                />
                <v-text-field
                  v-model="editedItem.activeBeforeSum"
                  label="Активно от суммы заказа"
                />
                <v-text-field
                  v-model="editedItem.position"
                  label="Позиция"
                  hint="Больше - первее"
                  :persistent-hint="true"
                />
                <v-select
                  v-model="editedItem.type"
                  :items="typesList"
                  label="Тип"
                  single-line
                />
                <v-card v-if="isPickpoint(editedItem.type)">
                  <v-card-title>
                    <span class="headline">Точки самовывоза</span>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="addNewPickpointsDialog">
                      <template #activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">Добавть точку самовывоза</span>
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col sm="12">
                              <v-text-field
                                v-model="newPickpointItem.name"
                                label="Название *"
                                :rules="[rules.required]"
                              />
                              <v-text-field
                                v-model="newPickpointItem.address"
                                label="Адрес *"
                                :rules="[rules.required]"
                              />
                              <v-text-field
                                v-model="newPickpointItem.phone"
                                label="Телефон"
                              />
                              <v-text-field
                                v-model="newPickpointItem.workDays"
                                label="Рабочие дни"
                              />
                              <v-text-field
                                v-model="newPickpointItem.workHours"
                                label="Рабочие часы"
                              />
                              <v-text-field
                                v-model="newPickpointItem.lat"
                                label="Широта"
                              />
                              <v-text-field
                                v-model="newPickpointItem.lng"
                                label="Долгота"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn color="blue darken-1" text @click="closeNewPickpointDialog">
                            Отмена
                          </v-btn>
                          <v-btn color="blue darken-1" text @click="addPickPoint">
                            Сохранить
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-title>
                  <v-card-text>
                    <v-list>
                      <v-list-item
                        v-for="point in editedItem.pickPoints"
                        :key="point.id"
                      >
                        <v-list-item-content>
                          {{ point.name }}
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-btn
                            icon
                            @click="openEditPickPoint(point)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-dialog
                            transition="dialog-bottom-transition"
                            width="500"
                            :value="deletePickpointDialog === point.id"
                            @input="toggleDeletePickpointDialog($event, point.id)"
                          >
                            <template #activator="{ on, attrs }">
                              <v-tooltip top>
                                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                                      mdi-delete
                                    </v-icon>
                                  </span>
                                </template>
                                Удалить
                              </v-tooltip>
                            </template>
                            <v-card>
                              <v-toolbar color="primary" dark class="text-center mb-6">
                                Подтвердите Действие
                              </v-toolbar>
                              <v-card-text>
                                Вы точно хотите удалить запись?
                              </v-card-text>
                              <v-card-actions class="justify-end">
                                <v-btn color="tertiary" dark @click="deletePickpointDialog = null">
                                  Отменить
                                </v-btn>
                                <v-btn color="primary" @click="deletePickpointItem(point.id)">
                                  Удалить
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
                <v-select
                  v-model="editedItem.status"
                  :items="statusList"
                  label="Статус"
                  single-line
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="closeEdit">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #body.prepend>
          <tr>
            <td></td>
            <td>
              <v-text-field
                v-model="filterName"
                clearable
              />
            </td>
            <td></td>
            <td>
              <v-text-field
                v-model="filterSum"
                clearable
              />
            </td>
            <td>
            </td>
            <td>
            </td>
            <td>
              <v-select
                v-model="filterType"
                :items="typesList"
                clearable
              />
            </td>
            <td>
              <v-select
                v-model="filterStatus"
                :items="statusList"
                clearable
              />
            </td>
          </tr>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.status="{ item }">
          {{ getStatus(item) }}
        </template>
        <template #item.type="{ item }">
          {{ getType(item) }}
        </template>
        <template #item.createdAt="{ item }">
          {{ new Date(item.createdAt * 1000).toLocaleString("ru-RU") }}
        </template>
        <template #item.name="{ item }">
          {{ getDeliveryFullName(item) }}
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { createDelivery, deleteDelivery, getDeliveries, updateDelivery } from '@/graphql/deliveries'
import { startCase } from 'lodash-es'

export default {
  name: 'DeliveriesList',
  components: {
  },
  layout: 'dashboard',
  apollo: {
    deliveries: {
      query: getDeliveries,
      variables () {
        const filter = {}
        if (this.filterName) {
          filter.name = parseFloat(this.filterName)
        }
        if (this.filterSum) {
          filter.sum = parseInt(this.filterSum)
        }
        if (this.filterStatus) {
          filter.status = this.filterStatus
        }
        if (this.filterType) {
          filter.type = this.filterType
        }
        if (this.filterStatus) {
          filter.status = this.filterStatus
        }
        return {
          filter,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      result ({ data }) {
        if (data?.deliveries?.data) {
          this.data = data.deliveries.data
          this.totalCount = data.deliveries.totalCount
        }
      },
      update: data => data?.deliveries?.data
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      dateCreatedVis: false,
      dateOrderedVis: false,
      datePaidVis: false,
      dateActivatedVis: false,
      searchNominal: '',
      totalCount: 0,
      active: [],
      open: [],
      deleteDialog: false,
      deletePickpointDialog: false,
      dialog: false,
      editDialog: false,
      editPickpointsDialog: false,
      addNewPickpointsDialog: false,
      isNewPickpointDialog: false,
      newItem: true,
      newPickpointItem: [],
      editPickpointItem: [],
      pickpointValidatorItem: [],
      filter: [],
      filterName: '',
      filterSum: '',
      filterFreeForSum: '',
      filterActiveAfterSum: '',
      filterType: '',
      filterStatus: 'ACTIVE',
      editedItem: {
        pickPoints: []
      },
      data: [],
      statusList: [
        { value: 'ACTIVE', text: 'Активно' },
        { value: 'NOT_ACTIVE', text: 'Не активно' }
      ],
      typesList: [
        { value: 'DELIVERY', text: 'Доставка' },
        { value: 'PICKPOINT', text: 'Самовывоз' },
        { value: 'CDEK', text: 'CDEK' }
      ],
      validatorMessages: {
        required: 'Необходимо заполнить'
      },
      headers: [
        ['id', 'Id'],
        ['name', 'Название'],
        ['position', 'Позиция'],
        ['sum', 'Стоимость'],
        ['freeForSum', 'Бесплатно при сумме заказа'],
        ['activeBeforeSum', 'Активно от суммы'],
        ['type', 'Тип'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          }),
      rules: {
        required: value => !!value || 'Обязательное поле.'
      }
    }
  },
  computed: {
  },
  watch: {
    dialog (val) {
      if (!val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    },
    editDialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    },
    addNewPickpointsDialog (val) {
      if (val) {
        if (this.isNewPickpointDialog) {
          this.editPickpointsDialog = Object.assign({})
        }
      } else {
        this.isNewPickpointDialog = true
      }
    }
  },
  methods: {
    getDeliveryFullName (item) {
      return item?.name + '(' + item?.group_name + ')'
    },
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    getType (item) {
      const ret = this.typesList.filter(row => row.value === item.type)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.type
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    toggleDeletePickpointDialog (value, slug) {
      this.deletePickpointDialog = value
          ? slug
          : null
    },
    save () {
      const saveData = {
        name: this.editedItem.name,
        sum: parseInt(this.editedItem.sum ?? 0),
        type: this.editedItem.type,
        status: this.editedItem.status
      }
      if (this?.editedItem?.position) {
        saveData.position = parseInt(this.editedItem.position)
      }
      if (this?.editedItem?.freeForSum) {
        saveData.freeForSum = parseInt(this.editedItem.freeForSum)
      }
      if (this?.editedItem?.activeBeforeSum) {
        saveData.activeBeforeSum = parseInt(this.editedItem.activeBeforeSum)
      }
      if (this.editedItem?.pickPoints?.length) {
        saveData.pickPoints = this.editedItem.pickPoints.map(point => ({
          name: point.name,
          address: point.address,
          phone: point.phone,
          lat: point.lat,
          lng: point.lng,
          workDays: point.workDays,
          workHours: point.workHours
        }))
      }
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: createDelivery,
              variables: {
                input: saveData
              }
            })
            .then((data) => {
              this.$apollo.queries.deliveries.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
        this.close()
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updateDelivery,
              variables: {
                id,
                input: saveData
              }
            })
            .then((data) => {
              this.$apollo.queries.deliveries.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
        this.closeEdit()
      }
      this.editedItem = []
    },
    deletePickpointItem (id) {
      const index = this.editedItem.pickPoints.findIndex(point => point.id === id)
      if (this.editedItem.pickPoints[index]) {
        this.editedItem.pickPoints.splice(index, 1)
      }
      this.deletePickpointDialog = null
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteDelivery,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.deliveries.refetch()
            this.deleteDialog = null
          })
          .catch((error) => {
            console.error(error)
          })
    },
    addPickPoint () {
      if (!this?.newPickpointItem?.name?.length) {
        this.pickpointValidatorItem.name = this.validatorMessages.required
        return
      }
      if (!this?.newPickpointItem?.address?.length) {
        this.pickpointValidatorItem.name = this.validatorMessages.required
        return
      }
      if (!this.isNewPickpointDialog) {
        const index = this.editedItem.pickPoints.findIndex(point => point.id === this.newPickpointItem.id)
        this.editedItem.pickPoints[index] = this.newPickpointItem
      } else {
        this.editedItem.pickPoints.push(this.newPickpointItem)
      }
      this.newPickpointItem = {}
      this.addNewPickpointsDialog = false
    },
    openEditPickPoint (item) {
      this.isNewPickpointDialog = false
      this.newPickpointItem = Object.assign({}, item)
      this.addNewPickpointsDialog = true
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    close () {
      this.dialog = false
    },
    closeEdit () {
      this.editDialog = false
    },
    closeNewPickpointDialog () {
      this.addNewPickpointsDialog = false
    },
    closeEditPickpointDialog () {
      this.editPickpointsDialog = false
    },
    formatDate (timestamp) {
      const date = new Date(timestamp)
      return date.form
    },
    isPickpoint (value) {
      return value === 'PICKPOINT'
    }
  }
}
</script>

<style scoped>

</style>
